// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3MBTe","inputWrap":"CustomTip_inputWrap__1l2Lp"};